import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SetItemPayload {
  name: string;
  value: any;
}

const initialState: any = {
  deviceId: "",
  guid: "",
};
export const linkUserDeviceItemSlice = createSlice({
  name: "linkUserDeviceItem",
  initialState,
  reducers: {
    setItem: (state, action: PayloadAction<SetItemPayload>) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } =
  linkUserDeviceItemSlice.actions;

export default linkUserDeviceItemSlice.reducer;
